import { IconProp } from '@fortawesome/fontawesome-svg-core';
import * as styles from './NavigationButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const NavigationButton = (p: {
  onClick: () => void;
  icon: IconProp;
  disabled: boolean;
}) => {
  return (
    <div
      className={[styles.navigation, p.disabled ? styles.disabled : ''].join(
        ' ',
      )}
      onClick={p.onClick}
    >
      {!p.disabled && <FontAwesomeIcon icon={p.icon} className={styles.icon} />}
    </div>
  );
};
